"use strict";

exports.__esModule = true;
exports.StyledPopoverContent = void 0;

var _styled = require("@manifest-ui/styled");

const StyledPopoverContent = (0, _styled.styled)('div', {
  themeKey: 'popover'
})({
  backgroundColor: 'white',
  borderRadius: 'medium',
  boxShadow: 'medium',
  zIndex: 'popover'
});
exports.StyledPopoverContent = StyledPopoverContent;